import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { withRouter } from "react-router-dom"

import { clientCapitalized } from "assets"
import { postLogout } from "services/auth/calls"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"

const Logout = props => {
  document.title = `Logout | Sensetek ${clientCapitalized}`

  const history = useHistory()

  const logoutUser = async () => {
    try {
      await postLogout()
    } catch (error) {
      console.error(error)
    } finally {
      localStorage.removeItem("token")
      history.push("/login")
    }
  }

  useEffect(() => {
    logoutUser()
  }, [])

  return <></>
}

Logout.propTypes = {
  history: PropTypes.object,
}

export default withRouter(Logout)
